import Component from '../abstracts/Component';
import Observer from "../utils/ObserverIntersection";

export default class PdpFixedBarComponent extends Component {

    get SELECTORS() {
        return {
            fixedBar: '#jsFixedBar',
            navBar:'#main-nav',
            mainSizeRow: '.c-sizes-row',
            toBagBtn: '.jsToBagBtn',
            toBagBtnOnFixedBar: '.jsStickyToBag',
            btnNotifyMe: '.jsNotifyMeBtn',
            btnNotifyMeOnFixedBar : '.jsStickyNotifyMe',
            sizesIntoFixedBar:'#jsFixedBar .c-s-r__size',
            unavailable: '[data-unavailable="true"]',
            formNotifyMe:'#jsNotifyMeForm',
            blockNotifyMe: '.c-pdp-notifyme',
            selectedBtnSize : '.selected-size',
            outOfStock: '[data-out-of-stock="true"]',
            hideStickyBarBlock: '[data-is-hide-sticky-bar="true"]',
            closeSizesBtn: '.jsCloseSizesFb',
            liveChat: '.live-chat[data-on-pdp-hide="true"]',
            ctaBlock: '.c-pdp__cta-block',
            closeZoomCta: '#jsCloseZoom',
            liveChatSalesforce: '.embeddedServiceHelpButton.livechat-button',
        };
    }
    constructor() {
        super();
        this.selecetedSizeClass = 'selected-size';
        this.showFormClass = 'show-form';
        this.fixedBarNotifyClass = 'notify-bar-mode';
        this.fixedBarChatClass = 'show-live-chat';
        this.showSizesClass = 'show-sizes';
        this.showBarClass = 'show-bar';
        this.pdpLiveChatClass ='on-pdp';
        this.isCtaOnView = true;
    }
    setFixedBarNotifyMe(){
        let barEl = document.querySelector(this.SELECTORS.fixedBar);
        let notifyClass = this.fixedBarNotifyClass;
        barEl.classList.add(notifyClass);
    }
    showForm(bool){
        let formBlock = document.querySelector(this.SELECTORS.blockNotifyMe);
        let showClass = this.showFormClass;
        if(!bool){
            formBlock.classList.remove(showClass);
        }else{
            formBlock.classList.add(showClass);
        }
    }
    triggerMainToBag(){
        const ctaEl = document.querySelectorAll(this.SELECTORS.toBagBtn);
        ctaEl.click();
    }
    sizeNotSelected(){
        let sizes = document.querySelectorAll(this.SELECTORS.selectedBtnSize);
        if(sizes.length <= 0){
            return true;
        }else{
            return false;
        }
    }
    observeCta() {
      const target = document.querySelector(this.SELECTORS.ctaBlock);
      let handler = (entries)=>{
        for (let entry of entries) {
          if(entry.intersectionRatio > 0) {
            this.showFixedBar(false);
            this.isCtaOnView = true;
          } else if (entry.intersectionRatio === 0) {
            this.isCtaOnView = false;
            this.showFixedBar(true);
            this.observeHideStickyBar();
          }
        }
      }
      const observer = new IntersectionObserver(handler);
      //return observer obj with target to be listened by media query & switched by connectObserver()
      return {
        observer:observer,
        target:target,
      }
    }
    connectObserver(obj, bool = true){
      let observer = obj.observer;
      let target = obj.target;
      if (target == null) return;
      if (bool) {
        observer.observe(target);
      } else {
        observer.unobserve(target);
      }
    }
    observeHideStickyBar() {
      new Observer(this.SELECTORS.hideStickyBarBlock, 10, null, (entries, observer)=>{
        for (let entry of entries) {
          if (entry.intersectionRatio > 0) {
            this.showFixedBar(false);
          } else if (entry.intersectionRatio === 0) {
            if (this.isCtaOnView == false || this.isMobile()) {
              this.showFixedBar(true);
            }
          }
        }
      });
    }
    scrollToForm(){
        const mainNav = document.querySelector(this.SELECTORS.navBar);
        const sizesRow = document.querySelector(this.SELECTORS.mainSizeRow);
        const fromTop = sizesRow.offsetTop -  mainNav.offsetHeight;
        const scrollOpt = {
            top:fromTop,
            left:0,
            behavior: 'smooth'
        }
        window.scrollTo(scrollOpt);
    }
    sizesIntoFixedBarHandler(){
        const sizes = document.querySelectorAll(this.SELECTORS.sizesIntoFixedBar);
        let closeLayerBtn = document.querySelector(this.SELECTORS.closeSizesBtn);

        for (let size of sizes){
            size.addEventListener('click',()=>{
                this.showSizesOnBar(false);
            })
        }
        closeLayerBtn.addEventListener('click',()=>{
            this.showSizesOnBar(false);
        })
    }
    showSizesOnBar(bool){
        const fixedBar = document.querySelector(this.SELECTORS.fixedBar);

        const showSizesClass = this.showSizesClass;
        if(bool){
            fixedBar.classList.add(showSizesClass);
        }else{
            fixedBar.classList.remove(showSizesClass);
        }
    }
    showFixedBar(bool){
        const fixedBar = document.querySelector(this.SELECTORS.fixedBar);
        const showBarClass = this.showBarClass;
        const pdpLiveChatClass = this.pdpLiveChatClass;
        const liveChatEl = document.querySelector(this.SELECTORS.liveChat);
        if (liveChatEl == null) {
          const liveChatEl = document.querySelector(this.SELECTORS.liveChatSalesforce);
        }
        if(bool){
            fixedBar.classList.add(showBarClass);
            if (liveChatEl != null) {
              liveChatEl.classList.add(pdpLiveChatClass);
            }
            // event launch
            var eventName = 'showFixedBar';
            var evt = document.createEvent("Events");
            evt.initEvent(eventName, true, true);
            document.dispatchEvent(evt);
        }else if(!bool){
            fixedBar.classList.remove(showBarClass);
            if (liveChatEl != null) {
              liveChatEl.classList.remove(pdpLiveChatClass);
            }
            // event launch
            var eventName = 'hideFixedBar';
            var evt = document.createEvent("Events");
            evt.initEvent(eventName, true, true);
            document.dispatchEvent(evt);
        }
    }
    showChatFixedBar(){
      let barEl = document.querySelector(this.SELECTORS.fixedBar);
      if(barEl){
        let chatClass = this.fixedBarChatClass;
        if($('button.helpButtonEnabled').length > 0){
          barEl.classList.add(chatClass);
        } else {
    	    barEl.classList.remove(chatClass);
        }
      }
    }
    ctaNotifyMeHandler(){
        const mainNotifyCta = document.querySelector(this.SELECTORS.btnNotifyMe);
        const closeZoomCta = document.querySelector(this.SELECTORS.closeZoomCta);
        const stickyCta = document.querySelector(this.SELECTORS.btnNotifyMeOnFixedBar);
        let handlerDesk = ()=>{
            mainNotifyCta.click();
            this.scrollToForm();
            closeZoomCta.click();
        };
        let handlerMobile = ()=>{
            this.showSizesOnBar(true);
            //if(this.sizeNotSelected()){
            //    this.showSizesOnBar(true);
            //}else{
            //    mainNotifyCta.click();
            //}
        }
        stickyCta.addEventListener('click',handlerDesk);
        if(this.isMobile()){
            stickyCta.removeEventListener('click',handlerDesk);
            stickyCta.addEventListener('click',handlerMobile);
        }
    }
    ctaToBagHandler(){
        const ctaEl = document.querySelector(this.SELECTORS.toBagBtnOnFixedBar);
        ctaEl.addEventListener('click',()=>{
            if(this.sizeNotSelected()){
                this.showSizesOnBar(true);
            }
        });
    }
    setSizeErrorMessage(message){
        let mainSizeRow = document.querySelector(this.SELECTORS.mainSizeRow);
        mainSizeRow.dataset.errorMessage = message;
    }
    isMobile() {
      let isMobile = false;
      try {
        let mq = window.matchMedia('(max-width: 767px)');
        isMobile = mq.matches;
      } catch(e) {
        this.log("window.matchMedia function not available");
      }
      return isMobile;
    }
    isViewport(minMax,viewport){
        let mq = window.matchMedia(`(${minMax}-width:${viewport}px)`);
        let isViewport = mq.matches;
        return isViewport;
    }
    initFixedBar() {
      let mq = window.matchMedia('(max-width:767px)');
      let ctaObserver = this.observeCta();

      if (mq.matches) {
        window.scrollTo({top: 0, behavior: 'smooth'});
        this.showFixedBar(true);
        this.observeHideStickyBar();
        this.connectObserver(ctaObserver, false);
      } else {
        this.connectObserver(ctaObserver);
      }

      mq.addListener((e)=>{
        if (e.matches) {
          this.showFixedBar(true);
          this.observeHideStickyBar();
          this.connectObserver(ctaObserver, false);
        } else {
          this.connectObserver(ctaObserver);
        }
      });
    }
    render() {
        if (document.querySelector(this.SELECTORS.fixedBar)) {
            this.initFixedBar();
            this.ctaNotifyMeHandler();
            this.ctaToBagHandler();
            this.sizesIntoFixedBarHandler();
        }
        if(document.querySelector(this.SELECTORS.outOfStock)){
            this.setFixedBarNotifyMe();
        }
        let myName = this.constructor.name;
        console.log(`[${myName}] Rendering..`);
    }
}
